import gql from 'graphql-tag'
import { apiQL } from '@/api'
import axios from 'axios'

export default {
  methods: {
    whatsapp(text, windowName = 'Deel dit op Whatsapp') {
      window.open(
        `https://api.whatsapp.com/send?text=${text} ${window.location.href}`,
        windowName,
        'width=626,height=436'
      )
    },
    facebook(windowName = 'Deel dit op Facebook') {
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${window.location.href}`,
        windowName,
        'width=626,height=436'
      )
    },
    twitter(
      text = 'Check out Act Circular Now',
      windowName = 'Deel dit op Twitter'
    ) {
      const url = encodeURIComponent(window.location.href)
      const encodedText = encodeURIComponent(text)

      window.open(
        `https://twitter.com/intent/tweet?url=${url}&text=${encodedText}`,
        windowName,
        'width=626,height=436'
      )
    },
    async donateMail(body = ' body ding') {
      try {
        const q = gql`
          query {
            globalSets(handle: "Settings") {
              ... on settings_GlobalSet {
                donationsToEmail
              }
            }
          }
        `
        const result = await apiQL(q)
        const to = result.data.globalSets[0].donationsToEmail

        const base = process.env.NODE_ENV === 'production' ? '/' : '/'
        const origin = window.location.origin
        const point = origin + '/' + base + 'mail.php'

        console.log(point)
        var fd = new FormData()
        fd.append('secret', 'v0vZJuKoH+NXdfH6bpFL/o3sqZom2/Zk')
        fd.append('to', to)
        fd.append('subject', 'Donate to Act Circular Now')
        fd.append('message', body)
        await axios.post(point, fd)
      } catch (error) {
        console.log(error)
        this.error = error
      }
    },
    async feedbackMail(subject = 'Feedback op Act Circular Now') {
      try {
        const q = gql`
          query {
            globalSets(handle: "Settings") {
              ... on settings_GlobalSet {
                suggestionsToEmail
              }
            }
          }
        `
        const result = await apiQL(q)
        const email = result.data.globalSets[0].suggestionsToEmail

        const encodedSubject = encodeURIComponent(subject)
        window.open(`mailto:?to=${email}&subject=${encodedSubject}`)
      } catch (error) {
        console.log(error)
        this.error = error
      }
    },
    mail({ to = '', subject = '', text = '' }) {
      window.open(`mailto:?to=${to}&subject=${subject}&body=${text}`)
    },
  },
}
